interface MicrosoftLogoProps {
  className?: string;
}

/**
 * The four-square Microsoft mark, inlined as SVG.
 *
 * Inline rather than an <img src> because the strict CSP blocks external images,
 * and Microsoft's sign-in branding guidance requires the logo on the button.
 */
export function MicrosoftLogo({ className }: MicrosoftLogoProps) {
  return (
    <svg className={className} viewBox="0 0 21 21" aria-hidden="true" focusable="false">
      <rect x="1" y="1" width="9" height="9" fill="#F25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
      <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
  );
}
